"use client";

import { useEffect } from "react";

export default function GlobalError({
	error,
}: {
	error: Error & { digest?: string };
}) {
	useEffect(() => {
		// Only capture exceptions in production
		if (process.env.NODE_ENV === "production") {
			import("@sentry/nextjs").then((Sentry) => {
				Sentry.captureException(error);
			});
		} else {
			console.error("Global error:", error);
		}
	}, [error]);

	return (
		<html lang="en">
			<body className="flex h-screen items-center justify-center bg-gray-50">
				<div className="text-center">
					<h1 className="text-4xl font-bold text-gray-900">
						Something went wrong!
					</h1>
					<p className="mt-2 text-gray-600">
						We&apos;ve been notified and are working to fix the issue.
					</p>
					<button
						type="button"
						onClick={() => window.location.reload()}
						className="mt-4 rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
					>
						Try again
					</button>
				</div>
			</body>
		</html>
	);
}
